<template>
  <div>
    <div class="surveyApprovalQuestions">
      <br />
      <!-- <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div> -->

      <b-modal class="no-print" id="editTitleModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
        hide-footer centered lazy size="sm">
        <div>
          <h3 class="text-center">
            Edit {{ editTitle.name }}
          </h3>
          <b-col>
            <div>
              <b-form-group label="Order No:" label-for="input-2" description="">
                <b-form-input id="input-2" v-model="editTitle.si_no" type="text" placeholder="eg: 3"></b-form-input>
                <span class="text text-info"></span>
              </b-form-group>
            </div>
            <div>
              <b-form-group label="Title Name:" label-for="input-1" description="">
                <b-form-input id="input-1" v-model="editTitle.name" type="text" placeholder="eg: Title 1"
                  required></b-form-input>
              </b-form-group>
            </div>
          </b-col>

          <b-row>
            <b-col sm="12" style="text-align:right;">
              <b-button variant="success" class="text-white sm" size="sm" @click="updateEditTitle">Submit</b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-container class="bg-light p-2 rounded">
        <b-row>
          <b-col md="12">
            <div class="closeBtn mb-2 text-right">
              <p @click="closeCurrentTab()" class="btn m-0">
                <i class="fas fa-window-close fa-4x text-danger"></i>
              </p>
            </div>
            <h6 style="font-size: 24px; font-weight: 600; text-align: center">
              Add Questions for:
              <span class="text-info">{{ admissionformDetails.name }} - {{ admissionformDetails.section.name }}</span>
            </h6>

            <div class="d-flex justify-content-left mt-2">
              <b-button v-if="admissionformQuestions.length == 0 || !addQues"
                class="btn btn-info d-flex align-items-center me-2 mr-2"
                @click="addQues = true; prepareAddingQuestion()" style="padding: 0.15rem 0.5rem; font-size: 0.75rem;">
                <i class="fas fa-plus-square me-1" style="font-size: 0.85rem;"></i>
                Add Question
              </b-button>

              <button v-if="admissionformQuestions.length == 0 || !addQues"
                class="btn btn-warning d-flex align-items-center" @click="addingTitle()"
                style="padding: 0.15rem 0.5rem; font-size: 0.75rem;">
                Add Title
              </button>
            </div>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1" description="">
                <label class="" for="">Form Guidelines:</label>
                <b-form-input id="input-1" v-model="form_guideline" type="text"
                  placeholder="Enter a text that can see when fill the form"></b-form-input>
                <b-button class="mt-1" @click="saveFormGuideline"
                  v-if="(admissionformDetails.form_guideline != form_guideline)" variant="primary">Save</b-button>
              </b-form-group>
            </b-col>
            <div class="questions" v-if="admissionformQuestions.length != 0">
              <b-form class="border-0">
                <div class="question border border-info rounded p-3 mt-2 bg-white"
                  v-for="(question, questionIndex) in admissionformQuestions" :key="questionIndex">
                  <b-overlay :show="loadQuestion" spinner-variant="primary" spinner-type="grow" spinner-small
                    rounded="md">
                    <!-- Title Block -->
                    <div v-if="question.type == 'title'" class="border-warning m-1"
                      style="border: 2px solid; border-radius: 6px;">
                      <p style="font-size: 15px !important;" class="m-2 text-center font-weight-bold">
                        {{ question.name }}
                        <i style="font-size: 12px !important;" class="fas fa-edit text-primary text-sm btn p-0 mx-1"
                          @click="openEditTitle(question.id)"></i>
                        <i style="font-size: 12px !important;" class="fas fa-trash-alt text-danger text-sm btn p-0 mx-1"
                          @click="deleteTitle(question.id)"></i>
                      </p>
                    </div>

                    <!-- Question Block -->
                    <div v-else>
                      <div class="quesView" v-if="question.disabled">
                        <div class="quesNoAndQues" style="
              font-size: 14px;
              font-weight: 600;
              display: flex;
              justify-content: space-between;
            ">
                          <p class="mb-2">
                            {{ question.question_no }}:
                            <span>{{ question.name }}</span>
                          </p>
                          <div v-if="question.id != ''">
                            <div v-if="question.disabled == true">
                              <b-button variant="info" style="font-size: 12px" size="sm"
                                @click="editAdmissionformQuestion(questionIndex)">Edit</b-button>
                              <span class="text-danger btn p-0 m-0 ml-2" @click="
                                deleteAdmissionformQuestion(question.id, questionIndex)
                                "><i class="fas fa-trash"></i></span>
                            </div>
                            <div v-else>
                              <b-button variant="info" style="font-size: 12px" size="sm"
                                v-if="question.disabled == false"
                                @click="prepareAdmissionformQuestionsForUpdating(questionIndex)">Save</b-button>
                            </div>
                          </div>
                        </div>

                        <!-- Question Settings Display -->
                        <div style="font-size: 12px; font-weight: 600">
                          <div class="d-flex flex-wrap">
                            <p :class="question.allow_attachment
                              ? 'text-success mb-2'
                              : 'text-danger mb-2'
                              ">
                              <span><i :class="question.allow_attachment
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                {{
                                  question.allow_attachment
                                    ? 'Attachment Allowed'
                                    : 'Attachment not allowed'
                                }}</span>
                            </p>
                            <p :class="question.input_attributes[0].answerMandatory
                              ? 'text-success mb-2 ml-2'
                              : 'text-danger mb-2 ml-2'
                              ">
                              <span><i :class="question.input_attributes[0].answerMandatory
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                {{
                                  question.input_attributes[0].answerMandatory
                                    ? 'Answer Mandatory'
                                    : 'Answer not mandatory'
                                }}</span>
                            </p>
                          </div>
                          <div class="mb-2 d-flex flex-wrap">
                            <span :class="question.input_attributes[0].shortAnswer
                              ? 'text-success'
                              : 'text-danger'
                              "><span><i :class="question.input_attributes[0].shortAnswer
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                Short Answer</span>
                            </span>
                            <span :class="question.input_attributes[0].paragraph
                              ? 'text-success ml-2'
                              : 'text-danger ml-2'
                              "><span><i :class="question.input_attributes[0].paragraph
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                Paragraph</span></span>
                          </div>

                          <div class="mb-2 d-flex flex-wrap">
                            <span :class="question.input_attributes[0].multiChoice
                              ? 'text-success'
                              : 'text-danger'
                              "><span><i :class="question.input_attributes[0].multiChoice
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                Mutichoice</span></span>
                            <span :class="question.input_attributes[0].checkboxes
                              ? 'text-success ml-2'
                              : 'text-danger ml-2'
                              "><span><i :class="question.input_attributes[0].checkboxes
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                Radio Buttons</span></span>
                            <span :class="question.input_attributes[0].dropdown
                              ? 'text-success ml-2'
                              : 'text-danger ml-2'
                              "><span><i :class="question.input_attributes[0].dropdown
                                ? 'far fa-check-circle ml-1'
                                : 'far fa-times-circle ml-1'
                                "></i>
                                Dropdown</span></span>
                          </div>

                          <div class="mb-2 d-flex" v-if="
                            question.input_attributes[0].multiChoice ||
                            question.input_attributes[0].checkboxes ||
                            question.input_attributes[0].dropdown
                          ">
                            <p v-for="(choice, choiceIndex) in question.answers" :key="choiceIndex"
                              class="text-white p-1 bg-success rounded ml-2">
                              {{ choice }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Question Edit View -->
                      <div class="editView" v-else>
                        <!-- Q No -->
                        <b-form-group class="questionNo">
                          <div class="w-100 d-flex justify-content-between">
                            <div>
                              <b-form-input placeholder="Q No" style="width: 100px" v-model="question.question_no"
                                :class="{
                                  'form-group-error':
                                    $v.admissionformQuestions.$each[questionIndex]
                                      .question_no.$error,
                                }"></b-form-input>

                              <span class="input-error-message" v-if="
                                !$v.admissionformQuestions.$each[questionIndex].question_no
                                  .required &&
                                $v.admissionformQuestions.$each[questionIndex].question_no
                                  .$dirty
                              ">Question Number is mandatory!</span>
                            </div>

                            <div class="deleteQuestion" v-if="question.id == ''">
                              <span class="btn p-0 m-0 text-danger"
                                @click="admissionformQuestions.splice(questionIndex, 1)"><i
                                  class="fas fa-minus-circle"></i></span>
                            </div>

                            <div v-if="question.id != ''">
                              <b-button variant="info" style="font-size: 12px" size="sm"
                                v-if="question.disabled == true"
                                @click="editAdmissionformQuestion(questionIndex)">Edit</b-button>
                              <div v-else>
                                <b-button variant="info" style="font-size: 12px" size="sm"
                                  @click="prepareAdmissionformQuestionsForUpdating(questionIndex)">Save</b-button>
                                <span class="text-danger btn p-0 m-0 ml-2"
                                  @click="deleteAdmissionformQuestion(question.id, questionIndex)"><i
                                    class="fas fa-trash"></i></span>
                              </div>
                            </div>
                          </div>
                        </b-form-group>

                        <!-- Q Text -->
                        <b-form-group class="question">
                          <b-form-input placeholder="Question" v-model="question.name" :class="{
                            'form-group-error':
                              $v.admissionformQuestions.$each[questionIndex].name.$error,
                          }"></b-form-input>
                          <span class="input-error-message" v-if="
                            !$v.admissionformQuestions.$each[questionIndex].name.required &&
                            $v.admissionformQuestions.$each[questionIndex].name.$dirty
                          ">Question is mandatory!</span>
                        </b-form-group>

                        <!-- Attachments + Mandatory -->
                        <b-form-group label="1) Allow Attachment">
                          <div class="d-flex">
                            <b-form-checkbox size="sm" v-model="question.allow_attachment" :class="{
                              'form-group-error':
                                $v.admissionformQuestions.$each[questionIndex]
                                  .allow_attachment.$error,
                            }">Allow Attachment</b-form-checkbox>
                            <b-form-checkbox size="sm" v-model="question.input_attributes[0].answerMandatory" :class="{
                              'form-group-error':
                                $v.admissionformQuestions.$each[questionIndex]
                                  .allow_attachment.$error,
                            }" class="ml-4">Answer Mandatory</b-form-checkbox>
                          </div>
                        </b-form-group>

                        <!-- Answer Type -->
                        <b-form-group label="2) Answer Type">
                          <div class="d-flex">
                            <b-form-checkbox size="sm" :disabled="question.input_attributes[0].paragraph ||
                              question.input_attributes[0].multiChoice ||
                              question.input_attributes[0].checkboxes ||
                              question.input_attributes[0].dropdown
                              " v-model="question.input_attributes[0].shortAnswer" :class="{
                                'form-group-error':
                                  $v.admissionformQuestions.$each[questionIndex]
                                    .allow_attachment.$error,
                              }">Short Answer</b-form-checkbox>
                            <b-form-checkbox size="sm" :disabled="question.input_attributes[0].shortAnswer ||
                              question.input_attributes[0].multiChoice ||
                              question.input_attributes[0].checkboxes ||
                              question.input_attributes[0].dropdown
                              " v-model="question.input_attributes[0].paragraph" class="ml-2" :class="{
                                'form-group-error':
                                  $v.admissionformQuestions.$each[questionIndex]
                                    .allow_attachment.$error,
                              }">Paragraph</b-form-checkbox>
                          </div>
                        </b-form-group>

                        <!-- Choices -->
                        <b-form-group label="3) Choices Display View for Students">
                          <div class="d-flex">
                            <b-form-checkbox size="sm" :disabled="question.input_attributes[0].checkboxes ||
                              question.input_attributes[0].dropdown ||
                              question.input_attributes[0].shortAnswer ||
                              question.input_attributes[0].paragraph
                              " v-model="question.input_attributes[0].multiChoice" :class="{
                                'form-group-error':
                                  $v.admissionformQuestions.$each[questionIndex]
                                    .allow_attachment.$error,
                              }">Multichoice</b-form-checkbox>
                            <b-form-checkbox size="sm" :disabled="question.input_attributes[0].multiChoice ||
                              question.input_attributes[0].dropdown ||
                              question.input_attributes[0].shortAnswer ||
                              question.input_attributes[0].paragraph
                              " v-model="question.input_attributes[0].checkboxes" class="ml-2" :class="{
                                'form-group-error':
                                  $v.admissionformQuestions.$each[questionIndex]
                                    .allow_attachment.$error,
                              }">Radio Buttons</b-form-checkbox>
                            <b-form-checkbox size="sm" :disabled="question.input_attributes[0].multiChoice ||
                              question.input_attributes[0].checkboxes ||
                              question.input_attributes[0].shortAnswer ||
                              question.input_attributes[0].paragraph
                              " v-model="question.input_attributes[0].dropdown" class="ml-2" :class="{
                                'form-group-error':
                                  $v.admissionformQuestions.$each[questionIndex]
                                    .allow_attachment.$error,
                              }">Drop-down</b-form-checkbox>
                          </div>
                        </b-form-group>

                        <!-- Choices Input -->
                        <b-form-group v-if="
                          question.input_attributes[0].multiChoice ||
                          question.input_attributes[0].checkboxes ||
                          question.input_attributes[0].dropdown
                        ">
                          <b-form-tags placeholder="Enter choice and press enter" v-model="question.answers"
                            :id="'questionChoices' + questionIndex" tag-variant="info" tag-pills size="md"
                            class="text-center" remove-on-delete :tag-validator="null" :class="{
                              'form-group-error':
                                $v.admissionformQuestions.$each[questionIndex].answers.$error,
                            }"></b-form-tags>
                          <span class="input-error-message" v-if="
                            !$v.admissionformQuestions.$each[questionIndex].answers
                              .required &&
                            $v.admissionformQuestions.$each[questionIndex].answers.$dirty
                          ">Minimum 2 choices is required!!</span>
                        </b-form-group>

                        <span class="input-error-message" v-if="
                          !$v.admissionformQuestions.$each[questionIndex].allow_attachment
                            .checked &&
                          $v.admissionformQuestions.$each[questionIndex].allow_attachment
                            .$dirty
                        ">Please Select atleast one from above 3.</span>
                      </div>
                    </div>
                  </b-overlay>
                </div>

                <!-- Buttons -->
                <br />
                <b-form-group>

                  <div class="d-flex justify-content-left mt-2">
                    <b-button class="btn btn-info d-flex align-items-center me-2 mr-2" @click="prepareAddingQuestion()"
                      style="padding: 0.15rem 0.5rem; font-size: 0.75rem;">
                      <i class="fas fa-plus-square me-1" style="font-size: 0.85rem;"></i>
                      Add Question
                    </b-button>

                    <button class="btn btn-warning d-flex align-items-center" @click="addingTitle()"
                      style="padding: 0.15rem 0.5rem; font-size: 0.75rem;">
                      Add Title
                    </button>
                  </div>

                </b-form-group>

                <b-form-group class="text-center">
                  <b-button @click="prepareAdmissionFormQuestionsPostData()" variant="success" size="md"
                    :disabled="admissionformButton.disabled">{{
                      admissionformButton.sub }}</b-button>
                </b-form-group>
              </b-form>

            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>


  </div>
</template>

<script>
import moment from "moment";
import { required, requiredIf } from "vuelidate/lib/validators";
export default {
  created() {
    this.getAdmissionFormDetails();
  },
  data() {
    return {
      fetchData: false,
      addQues: false,
      loadQuestion: false,
      admissionformQuestions: [],
      admissionformDetails: {},
      editTitle: {},
      titles: [],
      form_guideline: '',
      admissionformButton: {
        add: "Add Question",
        sub: "Submit",
        disabled: false,
      },
    };
  },
  validations: {
    admissionformQuestions: {
      required,
      $each: {
        question_no: {
          required,
        },
        name: {
          required,
        },
        allow_attachment: {
          checked: (val, sAns) => {
            val;
            if (
              sAns.allow_attachment == false &&
              sAns.input_attributes[0].shortAnswer == false &&
              sAns.input_attributes[0].paragraph == false &&
              sAns.input_attributes[0].multiChoice == false &&
              sAns.input_attributes[0].checkboxes == false &&
              sAns.input_attributes[0].dropdown == false
            ) {
              return false;
            } else {
              return true;
            }
          },
        },

        answers: {
          required: requiredIf(function (choice) {
            let checkChoice = choice.input_attributes[0];
            if (
              checkChoice.multiChoice == true ||
              checkChoice.checkboxes == true ||
              checkChoice.dropdown == true
            ) {
              return true;
            }
          }),
        },
      },
    },
  },
  methods: {
    async deleteTitle(titleId) {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformtitles/${titleId}`;
      await this.$axios
        .delete(url)
        .then(() => {
          this.getAdmissionformQuestions();
        })
        .catch((error) => {
          error;
        });

      this.fetchData = false;
    },
    async updateEditTitle() {
      this.$bvModal.hide('editTitleModel');
      this.fetchData = true;

      // Step 1: Save any unsaved questions first
      const unsaved = this.admissionformQuestions.filter(
        q => q.type !== "title" && q.id === ""
      );

      if (unsaved.length > 0) {
        for (let ques of unsaved) {
          const admissionformQuestions = {
            question_no: ques.question_no,
            name: ques.name,
            summary: ques.summary,
            answers: ques.answers,
            allow_attachment: ques.allow_attachment,
            input_attributes: ques.input_attributes,
            section_id: this.$route.params.admissionform_section_id,
            grouping_tag: "",
          };

          try {
            const questionCreation = await this.createAdmissionFormQuestions(admissionformQuestions);

            if (questionCreation) {
              this.$toast.success(`Question number ${ques.question_no} created`, {
                position: "top-right",
                duration: 3000,
              });
            } else {
              this.$toast.error("Failed to save unsaved question(s). Please try again.", {
                position: "top",
                duration: 3000,
              });
              this.fetchData = false;
              return; // Stop if question save fails
            }
          } catch (error) {
            this.$toast.error("Failed to save unsaved question(s). Please try again.", {
              position: "top",
              duration: 3000,
            });
            this.fetchData = false;
            return;
          }
        }

        // Refresh questions after saving
        await this.getAdmissionformQuestions();
      }

      // Step 2: Update the title
      const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformtitles/${this.editTitle.id}`;

      try {
        await this.$axios.put(url, {
          section_id: this.editTitle.section_id,
          name: this.editTitle.name,
          si_no: this.editTitle.si_no,
        });

        // Refresh questions after title update
        await this.getAdmissionformQuestions();

        this.$toast.success("Title updated successfully", {
          position: "top-right",
          duration: 3000,
        });

      } catch (error) {
        this.$bvModal.show('editTitleModel');

        let errortxt = "Failed to update";
        if (error.response) {
          if (error.response.status === 422) {
            const errormsgs = error.response.data.errors;
            for (const key in errormsgs) {
              errortxt = errormsgs[key][0];
              break;
            }
          } else {
            errortxt = error.response.data.message || errortxt;
          }
        }

        this.$toast.error(errortxt, {
          position: "top",
          duration: 3000,
        });

        this.fetchData = false;
      }
    },
    openEditTitle(titleId) {
      this.editTitle = this.titles[titleId];
      this.$bvModal.show('editTitleModel');
    },
    async addingTitle() {
      // Step 1: Check if there are unsaved questions
      const unsaved = this.admissionformQuestions.filter(q => q.type !== "title" && q.id == "");

      if (unsaved.length > 0) {
        // Save unsaved questions first
        for (let ques of unsaved) {
          const admissionformQuestions = {
            question_no: ques.question_no,
            name: ques.name,
            summary: ques.summary,
            answers: ques.answers,
            allow_attachment: ques.allow_attachment,
            input_attributes: ques.input_attributes,
            section_id: this.$route.params.admissionform_section_id,
            grouping_tag: "",
          };

          let questionCreation = await this.createAdmissionFormQuestions(admissionformQuestions);

          if (questionCreation) {
            this.$toast.success(`Question number ${ques.question_no} created`, {
              position: "top-right",
              duration: 3000,
            });
          } else {
            this.$toast.error("Failed to save unsaved question(s). Please try again.", {
              position: "top",
              duration: 3000,
            });
            return; // stop, don’t add title if question save failed
          }
        }
        // Refresh questions after saving
        await this.getAdmissionformQuestions();
      }

      // Step 2: Add the title after all questions are saved
      let postData = {
        admissionform_section_id: this.$route.params.admissionform_section_id,
      };
      const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformtitles`;

      try {
        await this.$axios.post(url, postData);
        this.getAdmissionformQuestions();
      } catch (error) {
        this.$toast.error(
          "Failed to add section, Please try again. (" +
          (error.response?.data?.message || "Unknown error") +
          ")"
        );
      }
    },
    getAdmissionFormDetails() {
      const admissionformId = this.$route.params.admissionform_id;
      const sectionId = this.$route.params.admissionform_section_id;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${admissionformId}`;
      this.$axios
        .get(url)
        .then((response) => {
          this.admissionformDetails = {
            id: response.data.id,
            name: response.data.name,
            section: response.data.admissionformsections.find(s => s.id == sectionId),
            form_guideline: response.data.admissionformsections.find(s => s.id == sectionId).form_guideline,
            academic_year: response.data.academic_year,
            start_at: new Date(
              moment(
                moment
                  .utc(response.data.start_date, "YYYY-MM-DD HH:mm:ss")
                  .toDate()
              ).format()
            ),
            end_at: new Date(
              moment(
                moment.utc(response.data.end_date, "YYYY-MM-DD HH:mm:ss").toDate()
              ).format()
            ),

          };
          this.form_guideline = this.admissionformDetails.form_guideline
          this.getAdmissionformQuestions();
        })
        .catch((error) => {
          this.fetchData = false;
          error;
        });
    },
    async getAdmissionformQuestions() {
      this.fetchData = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${this.$route.params.admissionform_section_id}/admissionformquestions`;

      try {
        const response = await this.$axios.get(url);
        let questions = response.data.questions || [];
        let titles = response.data.titles || [];
        titles.forEach(title => {
          this.titles[title.id] = title;
        });

        let merged = [];

        // Normalize questions
        questions.forEach((q) => {
          merged.push({
            id: q.id,
            type: q.type ?? null,
            order_no: parseInt(q.question_no, 10), // use order field
            question_no: q.question_no,
            name: q.name,
            summary: q.summary,
            answers: q.answers,
            allow_attachment: q.allow_attachment == 1,
            input_attributes: q.input_attributes,
            grouping_tag: q.grouping_tag,
            disabled: true,
          });
        });

        // Normalize titles
        titles.forEach((t) => {
          merged.push({
            id: t.id,
            type: "title",
            order_no: parseInt(t.si_no, 10), // use order field
            si_no: t.si_no,
            name: t.name,
            disabled: true,
          });
        });

        // Sort everything by order_no, then titles come before questions if equal
        merged.sort((a, b) => {
          if (a.order_no === b.order_no) {
            // Put titles before questions if same order
            if (a.type === "title" && b.type !== "title") return -1;
            if (a.type !== "title" && b.type === "title") return 1;
            return 0;
          }
          return a.order_no - b.order_no;
        });

        this.admissionformQuestions = merged;
        this.addQues = true;
        this.fetchData = false;
      } catch (error) {
        console.error(error);
        this.fetchData = false;
      }
    },

    async saveFormGuideline() {
      const url =
        `${this.$store.getters.getAPIKey.mainAPI}/admissionformsections/${this.$route.params.admissionform_section_id}`
      await this.$axios
        .put(url, {
          form_guideline: this.form_guideline,
          admissionform_id: this.$route.params.admissionform_id,
        })
        .then(() => {
          this.admissionformDetails.form_guideline = this.form_guideline;
          this.$toast.success("Updated successfully", {
            position: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Failed to save", {
            position: "top",
            duration: 3000,
          });
        });
    },
    async deleteAdmissionformQuestion(questionId, questionIndex) {
      this.loadQuestion = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformquestions/${questionId}`;
      await this.$axios
        .delete(url)
        .then((response) => {
          this.$toast.success("Question Deleted", {
            position: "top",
            duration: 3000,
          });
          this.admissionformQuestions.splice(questionIndex, 1);
          this.loadQuestion = false;
          response;
        })
        .catch((error) => {
          this.$toast.success("Question Deleted", {
            position: "top",
            duration: 3000,
          });
          this.loadQuestion = false;
          error;
        });
    },
    async prepareAdmissionFormQuestionsPostData() {


      this.admissionformButton.add = "Please wait...";
      this.admissionformButton.sub = "Please wait...";
      this.loadQuestion = true;
      this.admissionformButton.disabled = true;

      try {
        for (let i = 0; i < this.admissionformQuestions.length; i++) {
          const ques = this.admissionformQuestions[i];

          // Only handle new Questions (not titles, not already saved)
          if (ques.type !== "title" && !ques.id) {
            const payload = {
              question_no: ques.question_no,
              name: ques.name,
              summary: ques.summary,
              answers: ques.answers,
              allow_attachment: ques.allow_attachment,
              input_attributes: ques.input_attributes,
              section_id: this.$route.params.admissionform_section_id,
              grouping_tag: "",
            };

            let created = await this.createAdmissionFormQuestions(payload);
            if (!created) {
              this.$toast.error(`Failed to save question: ${ques.question_no}`);
              continue;
            }
          }
        }

        this.$toast.success("All questions saved successfully!");
        await this.getAdmissionformQuestions(); // refresh list
      } catch (error) {
        console.error(error);
        this.$toast.error("Something went wrong while saving.");
      } finally {
        this.admissionformButton.add = "Add Question";
        this.admissionformButton.sub = "Submit";
        this.loadQuestion = false;
        this.admissionformButton.disabled = false;
      }
    },
    async createAdmissionFormQuestions(payload) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionformquestions`;
      try {
        const res = await this.$axios.post(url, payload);
        return res.data;
      } catch (error) {
        console.error("Error creating question:", error);
        return null;
      }
    },



    async prepareAddingQuestion() {
      this.addQuestion();
    },
    addQuestion() {
      this.admissionformQuestions.push({
        id: "",
        question_no: "",
        name: "",
        summary: "",
        answers: [],
        allow_attachment: false,
        input_attributes: [
          {
            shortAnswer: false,
            paragraph: false,
            multiChoice: false,
            checkboxes: false,
            dropdown: false,
            answerMandatory: true,
          },
        ],
        section_id: this.$route.params.admissionform_section_id
          ? this.$route.params.admissionform_section_id
          : "",
        grouping_tag: "",
        disabled: false,
      });
    },
    clearResponse(status) {
      this.admissionformButton.add = "Add Question";
      this.admissionformButton.sub = "Submit";
      this.loadQuestion = false;

      setTimeout(() => {
        if (status) {
          this.closeCurrentTab();
        }
        this.loadQuestion = false;
        this.admissionformButton.disabled = false;
      }, 3000);
    },
    editAdmissionformQuestion(questionIndex) {
      this.admissionformButton.disabled = true;
      const question = this.admissionformQuestions[questionIndex];
      this.admissionformQuestions.forEach((question) => {
        if (question.id != "") {
          question.disabled = true;
        }
      });
      question.disabled = false;
    },
    async prepareAdmissionformQuestionsForUpdating(admissionformQuesForUpdate) {


      this.loadQuestion = true;

      const ques = this.admissionformQuestions[admissionformQuesForUpdate];
      console.log("ques", ques);
      const admissionformQuestion = await {
        question_no: ques.question_no,
        name: ques.name,
        summary: ques.summary,
        answers: ques.answers,
        allow_attachment: ques.allow_attachment,
        input_attributes: ques.input_attributes,
        section_id: this.$route.params.admissionform_section_id,
        grouping_tag: "",
      };

      let questionUpdate = await this.updateAdmissionformQuestion(
        admissionformQuestion,
        ques.id
      );

      if (questionUpdate) {
        this.$toast.success(`Question number ${ques.question_no} updated`, {
          position: "top",
          duration: 3000,
        });

        await this.clearResponse(false);
        await this.getAdmissionformQuestions();
      }
      if (!questionUpdate) {
        this.$toast.error("Something Went Wrong, please try again!", {
          position: "top",
          duration: 3000,
        });
        this.clearResponse(false);
      }
    },
    async updateAdmissionformQuestion(admissionformQuestion, questionId) {
      let status = null;
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionformquestions/${questionId}`;
        await this.$axios.put(url, admissionformQuestion);
        status = true;
      } catch (error) {
        console.error("Error updating admission form question:", error);
        status = false;
      }
      return status;
    }
  },
};
</script>

<style>
.surveyApprovalQuestions {
  overflow: hidden;
}
</style>